export default __webpack_public_path__ + "static/media/backIcon.cf9834e9.svg";